const keyMap = {
  settings: "ctrl+q"
};

export default keyMap;



// WEBPACK FOOTER //
// ./src/utils/keyMap.js